import { ContentEntity, ContentNode, Dictionary, EntityTypeName, Image, ImageAsset, ImageEntity, Page } from "@shapeable/types";
import { Deposit } from '@shapeable/copper-connect-types';
import { WithAuthenticationRequiredOptions } from '@auth0/auth0-react';

export const METALLOGENICA_PORTAL_DEPOSIT_URL="https://dmgeode.com/DepositPortal.aspx?DepositID=";

export const PAGE_EXPLORER: Page = {
  id: 'explorer',
  slug: 'explorer',
  path: '/explorer',
};

export const WITH_AUTHENTICATION_REQUIRED_OPTIONS: WithAuthenticationRequiredOptions = {
  loginOptions: {
    appState: { targetUrl: '/explorer' },
  }
};

export const CopperAiDescription: ContentNode = {
  text: "This innovative tool is designed to facilitate collaboration among industry leaders, policymakers, and researchers in pursuit of sustainable mining practices."
}

export const ENTITY_OPEN_GRAPH_FIELDS = `openGraph { id title description { id text } image { id url } }`;
export const ENTITY_SCHEMA_FIELDS = `_entityTypeName _schema { label pluralLabel }`;

export const GptBannerIntro: ContentEntity = { 
  intro: {
    text: "Our AI assistant specifically trained on Copper Connect's value chain themes. It has the capability to navigate the entire Copper Connect website on your behalf. It can explain valuable relationships and connections between important topics covered on the site and surface the most relevant related documents and articles you’d need. **Try it now!**" 
  }
};

export const DEFAULT_MAP_ENTITY_TYPE_NAMES: EntityTypeName[] = [
  'Organisation',
];

export const horizonItro: ContentNode = {
  text: "The horizons note the current state of this innovation, whether it is available now, in a state of evolution or emerging as a future solution."
}

export const CtaImage: ImageEntity = {
  id: 'cta-image',
  image: {
    url: 'https://res.cloudinary.com/shapeable/image/upload/v1744613059/copper-connect/image-asset/call-to-action-image_image__CO-Call-to-action2_qknksz.webp',
  }
}
